<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  «ВИКАР-ОЙЛ» предлагает гибкие условия поставки топлива для
                  наших клиентов в России и соседних регионах. Мы готовы
                  обеспечить доставку от 5 до 1 000 тонн высококачественных
                  нефтепродуктов, включая бензин, дизельное топливо и мазут.
                </p>
                <p>
                  «ВИКАР-ОЙЛ» осуществляет доставку нефтепродуктов с
                  максимальной эффективностью и надежностью. Мы гарантируем, что
                  каждая партия топлива будет доставлена в сохранности и в срок.
                </p>
                <p>
                  Примечание: «ВИКАР-ОЙЛ» зарекомендовала себя как надёжный
                  поставщик, предлагающий широкий ассортимент качественных
                  нефтепродуктов и оперативную логистику.
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+79175094809"
                          class="ViewPromo__advantage-contact-link"
                          >+7 (917) 509-48-09</a
                        ></strong
                      >
                    </p>
                  </div>
                </li>
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы поставок</h4>
                    <p>НБ Лыткарино, НБ Белые столбы, Газпромнефть Янос</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «ВИКАР-ОЙЛ»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1179,
    productId: 2003,
    name: 'ООО «ВИКАР-ОЙЛ»',
    inn: '5047285978 ',
  }),
};
</script>
